import React from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '@/components/Header';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { BookOpen, XCircle, AlertTriangle } from 'lucide-react';

const CommonMistakes = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-background">
      <Header />
      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="text-center mb-12">
          <div className="flex items-center justify-center mb-4">
            <div className="p-3 bg-primary/10 rounded-lg">
              <XCircle className="h-8 w-8 text-primary" />
            </div>
          </div>
          <h1 className="text-4xl font-bold text-foreground mb-4">
            Common Mistakes to Avoid
          </h1>
          <p className="text-xl text-muted-foreground max-w-3xl mx-auto">
            Learn from others' experiences and avoid common application pitfalls
          </p>
        </div>

        <div className="space-y-8">
          <Card>
            <CardHeader>
              <div className="flex items-center space-x-3">
                <XCircle className="h-6 w-6 text-red-500" />
                <CardTitle>Common Application Mistakes</CardTitle>
              </div>
            </CardHeader>
            <CardContent className="space-y-4">
              <ul className="list-disc pl-6 space-y-4">
                <li>
                  <strong>Late Application</strong>
                  <p className="text-muted-foreground mt-1">Waiting until the last minute to apply, risking illegal stay</p>
                </li>
                <li>
                  <strong>Incomplete Documentation</strong>
                  <p className="text-muted-foreground mt-1">Missing required documents or submitting without proper translations</p>
                </li>
                <li>
                  <strong>Incorrect Photos</strong>
                  <p className="text-muted-foreground mt-1">Submitting photos that don't meet official requirements</p>
                </li>
                <li>
                  <strong>Wrong Office</strong>
                  <p className="text-muted-foreground mt-1">Applying at the wrong voivodeship office based on residence</p>
                </li>
                <li>
                  <strong>Insufficient Funds</strong>
                  <p className="text-muted-foreground mt-1">Not having enough financial proof for the stay period</p>
                </li>
              </ul>
            </CardContent>
          </Card>

          <Card>
            <CardHeader>
              <div className="flex items-center space-x-3">
                <AlertTriangle className="h-6 w-6 text-yellow-500" />
                <CardTitle>How to Avoid These Mistakes</CardTitle>
              </div>
            </CardHeader>
            <CardContent className="space-y-4">
              <ul className="list-disc pl-6 space-y-2">
                <li>Start preparing your application at least 2-3 months in advance</li>
                <li>Use our document checklist to ensure you have everything</li>
                <li>Get professional photos taken at a photo studio</li>
                <li>Verify your correct voivodeship office before applying</li>
                <li>Keep all original documents and make copies</li>
                <li>Have your documents translated by a sworn translator</li>
                <li>Double-check all forms before submission</li>
              </ul>
            </CardContent>
          </Card>
        </div>

        <div className="mt-12 text-center">
          <button
            onClick={() => navigate('/knowledge-base/getting-started')}
            className="text-primary hover:text-primary/80 transition-colors"
          >
            ← Back to Getting Started
          </button>
        </div>
      </div>
    </div>
  );
};

export default CommonMistakes; 